<template>
    <form
        method="post"
        autocomplete="off"
        enctype="multipart/form-data"
        @submit.prevent="handleSubmit"
    >
        <div class="row pt-2">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="address"
                        >Address</label
                    >
                    <input
                        type="text"
                        name="address"
                        v-model="form.address"
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && v$.form.address.$error,
                        }"
                        autofocus
                    />
                    <span class="text-danger" v-if="v$.form.address.$errors">
                        {{ v$.form.address.$errors[0]?.$message }}
                    </span>
                </div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="city"
                        >City</label
                    >
                    <input
                        type="text"
                        name="city"
                        v-model="form.city"
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && v$.form.city.$error,
                        }"
                        autofocus
                    />
                    <span class="text-danger" v-if="v$.form.city.$errors">
                        {{ v$.form.city.$errors[0]?.$message }}
                    </span>
                </div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-sm-12 col-md-6">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="zip_code"
                        >Zip Code</label
                    >
                    <input
                        type="text"
                        name="zip_code"
                        v-model="form.zip_code"
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && v$.form.zip_code.$error,
                        }"
                        autofocus
                    />
                    <span class="text-danger" v-if="v$.form.zip_code.$errors">
                        {{ v$.form.zip_code.$errors[0]?.$message }}
                    </span>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="state"
                        >State</label
                    >
                    <select
                        name="state"
                        class="form-control"
                        v-model="form.state"
                        placeholder="State"
                        :class="{
                            'is-invalid': submitted && v$.form.state.$error,
                        }"
                    >
                        <option value=""></option>
                        <option value="AL">AL</option>
                        <option value="AK">AK</option>
                        <option value="AR">AR</option>
                        <option value="AZ">AZ</option>
                        <option value="CA">CA</option>
                        <option value="CO">CO</option>
                        <option value="CT">CT</option>
                        <option value="DC">DC</option>
                        <option value="DE">DE</option>
                        <option value="FL">FL</option>
                        <option value="GA">GA</option>
                        <option value="HI">HI</option>
                        <option value="IA">IA</option>
                        <option value="ID">ID</option>
                        <option value="IL">IL</option>
                        <option value="IN">IN</option>
                        <option value="KS">KS</option>
                        <option value="KY">KY</option>
                        <option value="LA">LA</option>
                        <option value="MA">MA</option>
                        <option value="MD">MD</option>
                        <option value="ME">ME</option>
                        <option value="MI">MI</option>
                        <option value="MN">MN</option>
                        <option value="MO">MO</option>
                        <option value="MS">MS</option>
                        <option value="MT">MT</option>
                        <option value="NC">NC</option>
                        <option value="NE">NE</option>
                        <option value="NH">NH</option>
                        <option value="NJ">NJ</option>
                        <option value="NM">NM</option>
                        <option value="NV">NV</option>
                        <option value="NY">NY</option>
                        <option value="ND">ND</option>
                        <option value="OH">OH</option>
                        <option value="OK">OK</option>
                        <option value="OR">OR</option>
                        <option value="PA">PA</option>
                        <option value="RI">RI</option>
                        <option value="SC">SC</option>
                        <option value="SD">SD</option>
                        <option value="TN">TN</option>
                        <option value="TX">TX</option>
                        <option value="UT">UT</option>
                        <option value="VT">VT</option>
                        <option value="VA">VA</option>
                        <option value="WA">WA</option>
                        <option value="WI">WI</option>
                        <option value="WV">WV</option>
                        <option value="WY">WY</option>
                    </select>
                    <span class="text-danger" v-if="v$.form.state.$errors">
                        {{ v$.form.state.$errors[0]?.$message }}
                    </span>
                </div>
            </div>
        </div>
        <button
            type="submit"
            class="mt-5 btn btn-outline-orange text-orange text-uppercase float-right"
        >
            Update Address
        </button>
    </form>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import {
    required,
    email,
    minLength,
    sameAs,
    requiredIf,
} from "@vuelidate/validators";

export default {
    props: ["modalType", "modalData"],
    emits: ["closeModal", "updateUserInfo"],
    components: {},
    setup() {
        const store = useStore();

        function updateUserAddress(form) {
            store.dispatch("updateUserAddress", form);
        }

        onMounted(() => {});

        return {
            updateUserAddress,
        };
    },
    data() {
        return {
            v$: useVuelidate(),
            form: {
                id: null,
                address: null,
                city: null,
                state: null,
                zip_code: null,
            },
            submitted: false,
        };
    },
    computed: {},
    validations() {
        return {
            form: {
                address: { required },
                city: { required },
                state: { required },
                zip_code: { required },
            },
        };
    },
    mounted() {
        this.clearFields();

        if (this.modalType == "edit") {
            this.populateData();
        }
    },
    methods: {
        handleSubmit(e) {
            this.submitted = true;

            this.v$.$validate();
            if (!this.v$.$error) {
                // if ANY fail validation
                this.updateUserAddress(this.form);
                this.$emit("updateUserInfo");
                this.$emit("closeModal");
            } else {
                // alert('Form failed validation')
            }
        },
        populateData() {
            this.form.id = this.modalData.id;
            this.form.address = this.modalData.address;
            this.form.city = this.modalData.city;
            this.form.state = this.modalData.state;
            this.form.zip_code = this.modalData.zip_code;
        },
        clearFields() {
            this.form.id = null;
            this.form.address = null;
            this.form.city = null;
            this.form.state = null;
            this.form.zip_code = null;
        },
    },
};
</script>
